import { render, staticRenderFns } from "./upload-file-resource-button.vue?vue&type=template&id=7e24a8db&"
import script from "./upload-file-resource-button.vue?vue&type=script&lang=js&"
export * from "./upload-file-resource-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports